import { render, staticRenderFns } from "./EmployeeRoleAdd.vue?vue&type=template&id=31c098df&scoped=true&"
import script from "./EmployeeRoleAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c098df",
  null
  
)

export default component.exports